'use client'

import useSWR, { type Fetcher, type Key, type SWRResponse } from 'swr'

import {
  CartControllerV2ApiFactory,
  type CartMetaDataV2,
} from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../../api'
import { useGlobalConfigContext } from '../../../global-config'

const getProductPageApiSwrFetchCartMetadata = (): Key =>
  `useProductPageApiSwrFetchSellerData`

export const useProductApiSwrFetchCartMetadata = (options?: {
  disabled: boolean
}): SWRResponse<CartMetaDataV2, Error> => {
  const client = useGlooApi(CartControllerV2ApiFactory)
  const globalConfig = useGlobalConfigContext()

  const fetcher: Fetcher<
    CartMetaDataV2
  > = async (): Promise<CartMetaDataV2> => {
    const response = await client.cartV2TenantMetadataGet({
      Accept_Language: globalConfig.language,
      tenant: globalConfig.tenantAndEnv,
    })

    return response.data
  }

  return useSWR(
    // if not enabled aka key is null, query will not run
    options?.disabled ? null : getProductPageApiSwrFetchCartMetadata(),
    fetcher,
  )
}
